import BaseModel from '../core/BaseModel'
export default class ProductSerialNumberInfoModel extends BaseModel {
    constructor() {
        super({ 
                name: "product_serial_number_info",
                tableName: 'core_product_serial_number_info'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false,
                computed: (data) => {
                    data.id = data.serial_number_id
                }
            },
            model_code: { 
                name: 'model_code', 
                type: "String", 
                label: 'Model sản phẩm',
                sortable: true,
                computed: (data) => {
                    data.model_code = (data.products !== undefined && data.products !== null) ? data.products.model_code  :  '';
                }
            },
            model_name: { 
                name: 'model_name', 
                type: "String", 
                label: 'Tên sản phẩm',
                sortable: true,
                computed: (data) => {
                    data.model_name = (data.products !== undefined && data.products !== null) ? data.products.name  :  '';
                }
            },
            serial_number: { 
                name: 'serial_number', 
                type: "String", 
                label: 'Serial number',
                sortable: true,
                computed: (data) => {
                    data.serial_number = (data.product_serial_number !== undefined && data.product_serial_number !== null) ? data.product_serial_number.serial_number  :  '';
                }
            },
            activation_date: { 
                name: 'activation_date', 
                type: "Date", 
                label: 'Ngày kích hoạt',
                sortable: true
            },
            verify_status: { 
                name: 'verify_status', 
                type: "Selection",
                label: 'Trạng thái nghiệm thu',
                dataType: 'Label', 
                filter: { type: 'select', visible: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                options: [{ value: 1, label: 'Đã nghiệm thu'}, { value: 0, label: 'Chờ nghiệm thu'}, { value: 2, label: 'Không nghiệm thu'}],
                sortable: true,
            },
            warranty_status: { 
                name: 'warranty_status', 
                type: "Selection",
                label: 'Trạng thái bảo hành',
                dataType: 'Label', 
                options: [{ value: 1, label: 'Đã kích hoạt'}, { value: 0, label: 'Chưa kích hoạt'}, { value: 2, label: 'Chờ kích hoạt'}, { value: 3, label: 'Đã kích hoạt'}, { value: 4, label: 'Hết bảo hành'}, { value: 6, label: 'Sản phẩm huỷ'}],
                filter: { type: 'select', visible: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                sortable: true,
                computed: (data) => {
                    data.warranty_status =  data.warranty_status == 5 ? 0 : data.warranty_status;
                }
            },
            request_activation_id: {
                refs: 'products { model_code name} product_serial_number { serial_number  }',
                display: false
            }
        },)
    }

}